import { IApiPriceFilteringRule, IApiPriceFilteringRuleUpdate, IApiRuleId } from '@cbridge-packages/api';
import { RuleTranslator } from '@cbridge-packages/rule';
import { IPriceFilteringRule, IPriceFilteringImportRule } from './priceFilteringRule.interface';

export namespace PriceFilteringRuleTranslator {
  export function fromApi(rule: IApiPriceFilteringRule): IPriceFilteringRule {
    return RuleTranslator.fromApiClientRule(rule);
  }

  export function toApi(rule: IPriceFilteringRule): IApiPriceFilteringRuleUpdate {
    return RuleTranslator.toApiClientRule(rule);
  }

  export function fromApiImport(rule: IApiPriceFilteringRule & IApiRuleId): IPriceFilteringImportRule {
    const result: IPriceFilteringImportRule = RuleTranslator.fromApiClientRule(rule);
    result.id = rule.id;

    return result;
  }
}
